import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { PointsTrackingService } from '../../services/points-tracking.service';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';

@Component({
    selector: 'app-points-tracking',
    templateUrl: './points-tracking.component.html',
    styleUrls: ['./points-tracking.component.scss'],
    standalone: false
})
export class PointsTrackingComponent implements OnInit, OnDestroy, IWidgetComponent {

    data: Widget;

    public overalloptions: any;     // easypiechart outer ring
    public requiredoptions: any;    // easypiechart inner ring

    @HostBinding('class')
    get size(): string {
        return 'col-md-' + this.data.Size.toString();
    }

    constructor(
        private logger: LoggerService,
        public pointsTrackingService: PointsTrackingService,

    ) {
        this.log("constructor", null, LogCategory.Constructor);

        this.overalloptions = {
            barColor: '#4B9CD3',
            trackColor: '#f9f9f9',
            scaleColor: '#dfe0e0',
            scaleLength: 0,
            lineCap: 'round',
            lineWidth: 8,
            size: 110,
            rotate: 0,
            animate: {
                duration: 1000,
                enabled: true
            }
        }

        this.requiredoptions = {
            barColor: '#3a773d',
            trackColor: '#f9f9f9',
            scaleColor: '#dfe0e0',
            scaleLength: 0,
            lineCap: 'round',
            lineWidth: 8,
            size: 80,
            rotate: 0,
            animate: {
                duration: 1000,
                enabled: true
            }
        }
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.PointsTracking, category);
    }

    public getPercentComplete(group): number {
        if ((group.pointsNeeded <= 0) && !((group.TotalRequiredItems - group.RequiredItemsCompleted) > 1)) {
            return 100;
        } else {
            return Math.round((group.PointsCompleted / group.TotalPointsRequired) * 100);
        }
    }

    ngOnInit(): void {
        this.log("ngOnInit", null, LogCategory.Init);
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", LogCategory.Destroy);
    }
}
